const CONSTANTS = {
    // monitoring
    ON_MONITORING_IS_LOADING: 'monitoring/ON_MONITORING_IS_LOADING',
    ON_MONITORING_IS_LIVE: 'monitoring/ON_MONITORING_IS_LIVE',
    ON_MONITORING_SET_BOUNDS: 'monitoring/ON_MONITORING_SET_BOUNDS',
    ON_MONITORING_SET_LAST_TS: 'monitoring/ON_MONITORING_SET_LAST_TS',
    ON_RAW_DATA: 'monitoring/ON_RAW_DATA',
    ON_CLEAR_RAW_DATA: 'monitoring/ON_CLEAR_RAW_DATA',
};

export { CONSTANTS };

export const CHART_MODE = {
    phases: 'phases',
    devices: 'devices',
    meters: 'meters'
}


